import actionTypes from './action-types';

const setTcfLoaded = () => {
    return {
        type: actionTypes.SET_TCF_LOADED
    };
};

const setAds = ads => {
    return {
        type: actionTypes.SET_ADS,
        payload: ads
    };
};

export default {
    setAds,
    setTcfLoaded
};
